module.exports = __webpack_public_path__ + "static/media/togo-appicon-2022.6bb88fa3.webp";